import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Vue from 'vue'
import app from './app.vue'
import router from './router'
import Vuetify  from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { GraphQLClient } from 'graphql-request'

Vue.config.productionTip = false

const graphcmsClient = new GraphQLClient(
	'https://api-us-east-1.graphcms.com/v2/cks6qjdse08np01xi72f77qrq/master'
  )

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
	  themes: {
		light: {
		  primary: "#14C6FF",
		  secondary: "#424242",
		  accent: "#82B1FF",
		  error: "#FF5252",
		  info: "#2196F3",
		  success: "#4CAF50",
		  warning: "#FFC107",
		  lightblue: "#14c6FF",
		  yellow: "#FFCF00",
		  pink: "#FF1976",
		  orange: "#FF8657",
		  magenta: "#C33AFC",
		  darkblue: "#1E2D56",
		  gray: "#909090",
		  neutralgray: "#9BA6C1",
		  green: "#2ED47A",
		  red: "#FF5c4E",
		  darkblueshade: "#308DC2",
		  lightgray: "#BDBDBD",
		  lightpink: "#FFCFE3",
		  white: "#FFFFFF"
		}
	  }
	}
  });

  Vue.mixin({
	beforeCreate () {
	  this.$graphcms = graphcmsClient
	}
  })

new Vue({
    render: h => h(app),
	vuetify : new Vuetify(),
    router
}).$mount('#app')
router.afterEach((to, from) => {
    //document.title = to.meta.title;    
});
